// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__gcGz4","error__content":"Error_error__content___P4uo","error__title":"Error_error__title__6HhQn"};